<template>
    <a @click="openManual" class="pull-right" style="font-size: 15px"><strong> <i class="fa fa-question-circle-o" /> Hilfe</strong></a>
</template>

<script>
import {popupCenter} from '@/javascript/misc.js'
export default {
    name: "Help",
    props: ['section'],
    methods: {
        openManual () {
            let manual = this.$router.resolve({path: '/manual/'+this.section});
            //window.open(manual.href, "_blank");
            popupCenter(manual.href, "Anleitung", 1550, 700)
        }
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/globals/Help.vue